import { render, staticRenderFns } from "./PageGoal.vue?vue&type=template&id=53858434&"
import script from "./PageGoal.vue?vue&type=script&lang=js&"
export * from "./PageGoal.vue?vue&type=script&lang=js&"
import style0 from "./PageGoal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports